export default __webpack_public_path__ + "static/media/signal-low.aa6ef647.svg";